import { useEffect, useRef } from 'react';
// @ts-ignore
import { storage } from '@gp/utils/utils';
import { STRATEGIC_STORAGE_KEY } from '@sg/constants/storageKeys';

/**
 * Auto-scrolls to a specific project card when returning from document preview
 */
export default function useProjectAutoScroll(
  projects: any[],
  loading: boolean
) {
  const hasScrolled = useRef(false);

  useEffect(() => {
    // Only scroll once and when data is loaded
    if (hasScrolled.current || loading || !projects || projects.length === 0) {
      return;
    }

    // Get the stored project ID from sessionStorage
    const storedProjectId = storage.getSessionStorageItem(
      STRATEGIC_STORAGE_KEY.WEEKLY_PROJECT_HIGHLIGHT_PROJECT_ID
    );

    if (!storedProjectId) {
      return;
    }

    // Scroll to the project card with this ID
    // Delay to ensure DOM is rendered (no topRef conflict here)
    setTimeout(() => {
      // Try to find the project element by data-project-id or id attribute
      const projectElement = document.querySelector(`[data-project-id="${storedProjectId}"], #project-${storedProjectId}`);
      
      if (projectElement) {
        projectElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        hasScrolled.current = true;
      }
      
      // Clear the stored ID after scrolling
      storage.removeSessionStorageItem(STRATEGIC_STORAGE_KEY.WEEKLY_PROJECT_HIGHLIGHT_PROJECT_ID);
    }, 100); // Small delay to ensure DOM is ready

  }, [projects, loading]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      // Clear the stored ID when leaving the page
      storage.removeSessionStorageItem(STRATEGIC_STORAGE_KEY.WEEKLY_PROJECT_HIGHLIGHT_PROJECT_ID);
    };
  }, []);
}

